import { render, staticRenderFns } from "./Hygiene.vue?vue&type=template&id=442b859e&scoped=true"
import script from "./Hygiene.vue?vue&type=script&lang=js"
export * from "./Hygiene.vue?vue&type=script&lang=js"
import style0 from "./Hygiene.vue?vue&type=style&index=0&id=442b859e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b859e",
  null
  
)

export default component.exports